import { render, staticRenderFns } from "./BeforeChangeWrapper.vue?vue&type=template&id=473a84fe&"
import script from "./BeforeChangeWrapper.vue?vue&type=script&lang=ts&"
export * from "./BeforeChangeWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports